// extracted by css-extract-rspack-plugin
export default {"contentWrapper":"a03P1"};